<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-2">{{'Mã khóa học' | translate}}</label>
      <div class="col-4">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma">
      </div>
      <label class="control-label col-2">{{'Tên khóa học' | translate}}</label>
      <div class="col-4">
        <input type="text" tabIndex="2" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2">{{'Mô tả' | translate}}</label>
      <div class="col-9">
        <input type="text" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.MoTa">
      </div>
      <div class="col-1">
        <input class="form-control"
               maxlength="20"
               tabindex="8"
               currencyMask
               [(ngModel)]="doituongSelect.ThuTu"
               name="value"
               [placeholder]="'STT'"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>
    <div class="row form-group">
      <label class="control-label col-2">{{'Ghi chú' | translate}}</label>
      <div class="col-4">
        <input type="text" tabIndex="9" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
      <label class="control-label col-2">{{'Môn/Lớp' | translate}}</label>
      <div class="col-2">
        <ng-select #slCapTren
                   class="twcollong"
                   autofocus
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputmonhocs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.MonHocId">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
      <div class="col-2">
        <input class="form-control"
               maxlength="20"
               tabindex="10"
               currencyMask
               [(ngModel)]="doituongSelect.Lop"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2">{{'Nội dung' | translate}}</label>
      <div class="col-10">
        <ejs-richtexteditor style="background-color:white" height='220px' #toolsRTE id='alltoolRTE_ch' [toolbarSettings]='tools' [showCharCount]='true' [(value)]='doituongSelect.ThongTinChiTiet'
                            [maxLength]='maxLength' [fileManagerSettings]='fileManagerSettings' [quickToolbarSettings]='quickToolbarSettings'
                            (actionBegin)='handleFullScreen($event)' (actionComplete)='actionCompleteHandler($event)'>
        </ejs-richtexteditor>
        <!--<textarea name="description" tabIndex="6" [(ngModel)]="doituongSelect.NoiDung" placeholder="Nội dùng bằng text" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="3"> </textarea>-->
      </div>
    </div>


    <div class="row form-group">
      <label class="control-label col-2">{{'Số tiền' | translate}}</label>
      <div class="col-3">
        <input class="form-control"
               maxlength="20"
               max="8"
               tabindex="12"
               currencyMask
               [(ngModel)]="doituongSelect.SoTien"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
      <label class="control-label col-2">{{'Chỉ còn' | translate}}</label>
      <div class="col-3">
        <input class="form-control"
               maxlength="20"
               max="8"
               tabindex="13"
               currencyMask
               [(ngModel)]="doituongSelect.GiamGia"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2">{{'Chi nhánh' | translate}}</label>
      <div class="col-3">
        <ng-select #slChiNhanh2
                   class="twcollong"
                   [tabIndex]="19"
                   [openOnEnter]="false"
                   [items]="dschinhanhs"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.DonViId">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell_1">{{item.Ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2">{{'Số buổi' | translate}}</label>
      <div class="col-3">
        <input class="form-control"
               maxlength="20"
               max="20"
               tabindex="13"
               currencyMask
               [(ngModel)]="doituongSelect.SoBuoi"
               name="value"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>

    </div>

    <div class="clearfix"></div>
    <div class="row">
      <div class="col-3">
        <div class="sample-container">
          <div id='uploadFileManager' class="fileupload" style="margin-top:1px">
            <ejs-uploader #uploadObj id='defaultfileupload'></ejs-uploader>
            <button ejs-button id='openBtn' (click)="btnClick()">{{'Ảnh đại diện' | translate}}</button>
          </div>

        </div>
      </div>
      <div class="col-9">
        <div class="row" style="margin-top:50px;margin-left:5px">
          <div class="col-md-12">
            {{doituongSelect.DuongDanAnh}}
          </div>
          <div class="col-md-12" style="float:right">
            <a *ngIf="doituongSelect.DuongDanAnh" href="{{doituongSelect.DuongDanAnh}}" target="_blank" class="mr-1 btn btn-labeled btn-success mb-2" type="button"><i class="fa fas fa-download"></i> {{'Tải xuống' | translate}}</a>
            <button *ngIf="doituongSelect.DuongDanAnh" (click)="deleteFile()" class="mr-1 btn btn-labeled btn-danger mb-2" type="button"><i class="fa fa-times"></i> {{'Xóa' | translate}}</button>
          </div>

        </div>
      </div>
    </div>




  </div>
  
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThai" />
        <span class="fa fa-check"></span> {{'Hoạt động' | translate}}
      </label>
    </div>
  </div>
  
  <div class="">
    <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
    <button style="float:left !important" *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
  </div>

</div>


<div id='target' class="control-section">
  <ejs-dialog #dialogObj id='dialog' [visible]='visible' [header]='dialogHeader' [animationSettings]='animationSettings' [showCloseIcon]='showCloseIcon' (open)="dialogOpen()" (close)="dialogClose()"
              [target]='target' [width]='dialogWidth'>
    <ejs-filemanager #filemanagerObj id='filemanager' (beforeSend)="OnbeforeSend($event)"
                     [ajaxSettings]='ajaxSettings' [toolbarSettings]='toolbarSettings'
                     [contextMenuSettings]='contextMenuSettings'
                     [allowMultiSelection]='false' (fileOpen)="onFileOpen($event)" [showThumbnail]="false">
    </ejs-filemanager>
  </ejs-dialog>
</div>
